import { useTranslation } from 'react-i18next';

import { DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Gift, Package } from 'lucide-react';

import { BaseImportViewProps } from './import-view-props';

export const ViewChooser: React.FC<BaseImportViewProps> = ({
  setImportView,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <DialogHeader>
        <DialogTitle data-testid="import-dialog-title">
          {t('components.import_flow.main_menu_title')}
        </DialogTitle>
      </DialogHeader>
      <div className="mt-6 space-y-3">
        <button
          className="flex w-full items-center gap-4 rounded-lg border p-4 hover:bg-muted"
          onClick={() => setImportView('products')}
          data-testid="physical-import-button"
        >
          <div className="flex h-12 w-12 items-center justify-center rounded-md bg-muted">
            <Package className="h-6 w-6" />
          </div>
          <div className="text-base font-medium">
            {t('general.products_physical')}
          </div>
        </button>
        <button
          className="flex w-full items-center gap-4 rounded-lg border p-4 hover:bg-muted"
          onClick={() => setImportView('coupons')}
        >
          <div className="flex h-12 w-12 items-center justify-center rounded-md bg-muted">
            <Gift className="h-6 w-6" />
          </div>
          <div className="text-base font-medium">
            {t('general.products_digital')}
          </div>
        </button>
      </div>
    </>
  );
};
